import type { CurrentUserWorkbookAccessResponse } from "@/business/business";

export type RosterQueryScope = {
  userId: string | undefined;
  visibility:
    | CurrentUserWorkbookAccessResponse["roster_visibility"]
    | undefined;
};
export const payrollRosterKey = (
  businessId: string | null,
  viewer?: RosterQueryScope,
) =>
  viewer
    ? (["payroll-roster", businessId, viewer] as const)
    : (["payroll-roster", businessId] as const);

export const payrollRosterVersionKey = (
  businessId: string | null,
  version: number | null,
  viewer?: RosterQueryScope,
) => [...payrollRosterKey(businessId, viewer), "version", version] as const;
